import { useTranslation } from 'react-i18next';

import { AuthLayout } from '@cold-ambulance/layout';
import { SuccessIcon } from '@cold-ambulance/ui';

export default function ResetPasswordEmailSent() {
  const { t } = useTranslation();
  return (
    <AuthLayout
      className="bg-[#F8F8F8]"
      title={
        <div className="flex flex-col items-center justify-center gap-y-6">
          <SuccessIcon />
          <p>{t('forgotPassword.emailSentTitle')}</p>
        </div>
      }
      subtitle={
        <p className="text-center">{t('forgotPassword.emailSentSubtitle')}</p>
      }
      center={true}
    >
      <></>
    </AuthLayout>
  );
}
